import { render, staticRenderFns } from "./leyIngresoMpal.vue?vue&type=template&id=0eb4dbf8&scoped=true"
import script from "./leyIngresoMpal.vue?vue&type=script&lang=js"
export * from "./leyIngresoMpal.vue?vue&type=script&lang=js"
import style0 from "./leyIngresoMpal.vue?vue&type=style&index=0&id=0eb4dbf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4dbf8",
  null
  
)

export default component.exports